export default {
  radar: {
    searchPlaceholder: "Search event, product, active ingredient, laboratory…",
    // Milestone-group view (R-30, §90)
    viewByBlock: "By catalogue block",
    scopeMarket: "Whole market",
    scopeUniverse: "Your universe",
    scopeHint: "Your universe: only events on your products and your competitors",
    blockEmpty: "No events this month",
    hitosInBlock: "{n} milestones with events",
    hitosInBlockOne: "1 milestone with events",
    sourceSince: "Monitored since {date}",
    moreInHito: "and {n} more: search for them or export the month",
    confirmedBy: "confirmed by {n} sources",
    expandAll: "Expand all",
    collapseAll: "Collapse all",
    viewByGroup: "By milestone group",
    viewBySource: "By source",
    groupHitos: "{n} distinct milestones this month",
    groupHitosOne: "1 milestone this month",
    colHito: "Milestone",
    noGroupEvents: "No events this month with that filter",
    allSources: "All sources",
    exportExcel: "Export Excel",
    exporting: "Exporting…",
    searching: "Searching…",
    resultsCount: "{n} events found",
    noResults: "No event matches your search",
    pageOf: "Page {page} of {total}",
    colDate: "Date",
    colSource: "Source",
    colProduct: "Event / Product",
    colActiveIngredient: "Active ingredient",
    colLaboratory: "Laboratory",
    title: "Regulatory Radar",
    subtitle: "Events from every HelixScan source, by block of the milestone catalogue",
    loading: "Loading regulatory radar…",
    loadErrorMsg: "Could not load the data. Check your connection.",
    retry: "Retry",
    eventsCount: "{n} events",
    monthsShort: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
    // Portfolio / competitor labels
    portfolio: "Portfolio",
    competitor: "Competitor",
    portfolioCount: "{n} Portfolio",
    competitorCount: "{n} Competitor",
    // KPIs
    kpiPreciosLabel: "Price reductions",
    kpiPreciosDesc: "SPRAH + CIPM",
    kpiFinanciacionLabel: "New reimbursements",
    kpiFinanciacionDesc: "SPRAH SNS",
    kpiAutorizacionesLabel: "Authorisations",
    kpiAutorizacionesDesc: "EMA · CMH · IPT",
    kpiRegulatorioLabel: "BOE + Nomenclátor",
    kpiRegulatorioDesc: "BOE publications",
    kpiPortfolio: "{n} portfolio",
    kpiComp: "{n} comp.",
    // Event row
    view: "View",
    previous: "prev.",
    paLabel: "A.I.",
    labLabel: "Lab.",
    // Lane (the API returns label/desc in ES; translated by key)
    laneLabel: {
      precios: "Price Changes",
      financiacion: "New Reimbursements",
      autorizaciones: "Authorisations & Pipeline",
      regulatorio: "BOE & Regulatory",
    },
    laneDesc: {
      precios: "SPRAH voluntary price cuts and CIPM price agreements",
      financiacion: "Medicines granted public (SNS) reimbursement",
      autorizaciones: "EMA authorisations, CMH meetings and IPT positioning reports",
      regulatorio: "BOE publications with pharmaceutical impact and Nomenclátor changes",
    },
    noEvents: "No events this month",
    nomenclatorUpdated: "medicines updated in the Nomenclátor de Prescripción (AEMPS)",
    showMore: "View {n} more",
    // Footer
    sourcesLabel: "Fuentes:",
    footerNote: "Data refresh automatically after each scheduled read of each source.",
  },
};
